import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';

import { CommonService } from 'src/app/services/common.service';
import { MediaTypes } from 'src/app/model/MediaTypes';
import { DamageTypeColour } from 'src/app/model/ImageData/GICInformation';
import { MapContainer } from '../../vrm-map/vrm-map.component';
import { PdfViewerComponent } from 'ng2-pdf-viewer';
import { GalleryItem } from '../gallery-item/gallery-item.component';

@Component({
  selector: 'vrm-gallery-item-detail',
  templateUrl: './gallery-item-detail.component.html',
  styleUrls: ['./gallery-item-detail.component.scss'],
})
export class GalleryItemDetailComponent implements OnInit {
  @Input() derMediaData: GalleryItem[];
  @Input() selectedItem: GalleryItem;

  @Output() onGoBackClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(PdfViewerComponent, { static: false })
  private pdfComponent: PdfViewerComponent;

  maxIndex: number;
  minIndex: number = 0;
  currentIndex: number = 0;
  mediaTypes = MediaTypes;
  damageTypeColour = DamageTypeColour;
  mapContainer = MapContainer;

  constructor(public cService: CommonService) {}

  ngOnInit() {
    this.currentIndex = this.derMediaData.indexOf(this.selectedItem);
    this.maxIndex = this.derMediaData.length - 1;
  }

  navigateToNextImage() {
    if (this.currentIndex !== this.maxIndex) {
      this.currentIndex++;
      this.selectedItem = this.derMediaData[this.currentIndex];
    }
  }

  navigateToPreviousImage() {
    if (this.currentIndex !== this.minIndex) {
      this.currentIndex--;
      this.selectedItem = this.derMediaData[this.currentIndex];
    }
  }

  onBackToGalleryClicked(): void {
    this.onGoBackClicked.emit(true);
  }

  pdfLoadComplete() {
    this.pdfComponent.updateSize();
  }
}
